<template>
  <b-list-group>
    <b-list-group-item v-for="log in changeLog" :to="{ name: 'ChangeLogList', params: { id: log.id } }" :id="'v' + log.appVersion" class="flex-column align-items-start" :key="log.id">
      <div class="d-flex w-100 justify-content-between">
        <h5 class="mb-1">v{{ log.appVersion }}</h5>
        <small>{{ $moment(log.createdAt).format('YYYY-MM-DD h:mma') }}</small>
      </div>
      <small>{{ log.tags.join(', ') }}</small>

      <p class="mb-1" v-html="nl2br(log.description)"></p>

      <small>{{ log.comments }}</small>
    </b-list-group-item>
  </b-list-group>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'ChangeLogList',
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters(['changeLog']),
  },
  mounted() {
    this.loadChangeLog()
  },
  methods: {
    ...mapActions({
      getChangeLog: 'getChangeLog',
    }),
    nl2br(str) {
      if (typeof str === 'undefined' || str === null) {
        return ''
      }
      var breakTag = '<br />'
      return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2')
    },
    async loadChangeLog() {
      try {
        await this.getChangeLog()
      } catch (error) {
        console.error('Error loading change logs:', error)
      } finally {
      }
    },
  },
}
</script>
